import { isUndefined, kebabCase } from 'lodash';
import type { BoundEnabledPerspective, BoundPerspective, Bubble } from 'configuration-schemas/bindings.types';
import { viewPath } from 'src/dao/tenantConfigClient';
import Axios from 'src/services/axios';
import { ASSORTMENT } from 'src/utils/Domain/Constants';
import { isEnabledPerspective, PerspectiveConfig } from 'src/utils/Domain/Perspective';

export const perspectiveToValue = (perspective: BoundEnabledPerspective | Bubble): string[] => {
  return 'view' in perspective
    ? (perspective.view as unknown as BoundEnabledPerspective[])
        .filter(isEnabledPerspective)
        .flatMap(perspectiveToValue)
    : [perspective.appType];
};

export const findPerspective = (allPerspectives: Record<string, any>, key: string) => {
  if (!isUndefined(allPerspectives[key])) {
    return allPerspectives[key];
  }
  // Check if perspective is inside any Bubble's view array
  for (const entry of Object.values(allPerspectives)) {
    const bubbleView = entry?.perspective?.view;
    if (Array.isArray(bubbleView)) {
      const matchingPerspective = bubbleView.find((viewItem) => viewItem.perspective.pathSlot === key);
      if (matchingPerspective) {
        return matchingPerspective;
      }
    }
  }
  return undefined;
};

/**
 * Takes the `pathSlot` of a perspective and generates the lookup key
 * (e.g. top-down => TopDown)
 */
export function getPerspectiveLookupKey(p: BoundPerspective) {
  return isEnabledPerspective(p) ? p.pathSlot : kebabCase(p.title);
}

export const getPerspectiveConfig = () => {
  return Axios.get<PerspectiveConfig>(`${viewPath}/${ASSORTMENT}/Perspectives`);
};
